import { withPending, withRejected, withFulFilled } from './commons';
import {
  CREATE_SESSION,
  DESTROY_SESSION,
  FIND_SESSION,
  UPDATE_SESSION,
  SIGN_LGPD_DOCUMENTS,
} from '../actions/access';
import { getSafe } from '../../util/verification/verifyUndefined';
import { AuthService } from 'src/services';

const authService = new AuthService()

// initial state
const INITIAL_STATE = {
  running: false,
  error: null,
  payload: {
    // token: null,
    // authenticated: false,
    // name: '',
    // photo: 'https://ui-avatars.com/api/?name=Not+Defined&background=0D8ABC&color=fff',
  },
  needChangePassword: authService.isChangePasswordToken() && authService.isAuthenticated(),
  // pendência de assinatura LGPD lida do token salvo (sobrevive ao reload)
  needSignDocuments: !!(authService.isAuthenticated()
    && getSafe(() => authService.getDecodedUser().need_sign_documents)),
};

// executer
const execute = (state = INITIAL_STATE, action) => {
  /*
    verifica se alguma requisição retornou erro 401, caso sim adiciona
    erro na autenticação
  */
  if (action.error && getSafe(() => action.payload.response.status) === 401) {
    return { ...state, running: false, error: action.payload };
  }
  switch (action.type) {
  // create
  case withPending(CREATE_SESSION):
    return { ...state, running: true, error: null };
  case withRejected(CREATE_SESSION):
    return { ...state, running: false, error: action.payload };
  case withFulFilled(CREATE_SESSION):
    return {
      ...state,
      running: false,
      payload: action.payload.data,
      needChangePassword: action.payload.data.needChangePassword,
      needSignDocuments: !!action.payload.data.needSignDocuments,
    };
  // update 
  case withPending(UPDATE_SESSION):
    return { ...state, running: true, error: null };
  case withRejected(UPDATE_SESSION):
    return { ...state, running: false, error: action.payload };
  case withFulFilled(UPDATE_SESSION):
    return {
      ...state,
      running: false,
      payload: action.payload.data,
      needChangePassword: false,
      needSignDocuments: !!action.payload.data.needSignDocuments,
    };
  // destroy
  case withPending(DESTROY_SESSION):
    return { ...state, running: true };
  case withRejected(DESTROY_SESSION):
    return { ...state, running: false, error: action.payload };
  case withFulFilled(DESTROY_SESSION):
    // sem sessão não há pendência LGPD; mantê-la impede o AuthorizationGuard de
    // recarregar a página e o logout (ex.: rejeitar a LGPD) não volta ao login
    return { ...state, running: false, payload: action.payload.data, needSignDocuments: false };
    // find (sync)
  case withPending(FIND_SESSION):
    return { ...state, running: true };
  case withRejected(FIND_SESSION):
    return { ...state, running: false, error: action.payload };
  case withFulFilled(FIND_SESSION):
    // também atualiza a flag LGPD: o login via TensaiRedirectAuth grava o token
    // sem reload, então o INITIAL_STATE não enxerga a claim
    return {
      ...state,
      running: false,
      payload: action.payload.data,
      needSignDocuments: !!action.payload.data.needSignDocuments,
    };
  // assinatura LGPD (relê o token novo, já sem pendência). Limpa o erro para
  // que um 401 recebido durante a pendência não derrube a sessão ao liberar
  case withFulFilled(SIGN_LGPD_DOCUMENTS):
    return {
      ...state,
      running: false,
      error: null,
      payload: action.payload.data,
      needSignDocuments: false,
    };
  default:
    return state;
  }
};

export default execute;
